

define(['angular', './directive'], function (angular) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('xo-add-card.selectcard.route', ['xo-add-card.selectcard.directive']).factory('$SelectCardRoute', function ($ComponentRoute) {

        return $ComponentRoute.extend('SelectCardRoute', {

            name: 'selectCard',
            directive: 'xo-select-card',
            titleContent: 'asideHeader.selectCard',
            children: []
        });
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-wallet-components/src/add-card/selectcard/route.js
 ** module id = 281
 ** module chunks = 1
 **/